import React from "react";
import "./Checkout.css";
import Subtotal from "./Subtotal";
import { useStateValue } from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct";
import FlipMove from "react-flip-move";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";

function Checkout() {
  const [{ basket, user }, dispatch] = useStateValue();

  return (
    <div className="checkout">
      <div className="checkout_left">
        <img
          className="checkout_ad"
          src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg"
          alt=""
        />

        <div>
          <h3 className="checkout_header">Hello,{user?.displayName}</h3>
          <h2 className="checkout_title">Your Shopping Basket</h2>
          {basket.length === 0 ? (
            <div className="empty_cart">
              <img
                src="https://img.icons8.com/plasticine/2x/shopping-cart-promotion.png"
                alt=""
              />
              <h2>You Cart Is Empty</h2>
              <Link to="/" className="add-to-cart">
                Add to the Cart
              </Link>
            </div>
          ) : (
            <Fade cascade="true">
              <FlipMove className="list-style">
                {basket.map((item) => (
                  <div>
                    <CheckoutProduct
                      id={item.id}
                      title={item.title}
                      image={item.image}
                      price={item.price}
                      rating={item.rating}
                    />
                  </div>
                ))}
              </FlipMove>
            </Fade>
          )}
          {/* CheckoutProduct */}
        </div>
      </div>

      <div className="checkout_right">
        <Subtotal />
      </div>
    </div>
  );
}

export default Checkout;
